import { h, Fragment } from "preact";
import { Label, ProductTypeRevision } from "../api/product-api";
import { group } from "../utils";
import { countries } from "../data/countries";
import { useEffect, useState } from "preact/hooks";
import { cn } from "../helpers/cn";
import { filterDefaultLabelsForRevision } from "../data/filterDefaultLabelsForRevision";

export function LabelSelect({
    revision,
    selected,
    onChange,
    autoSelect,
}: {
    revision: ProductTypeRevision;
    selected: Label | null;
    onChange: (label: Label | null) => void;
    autoSelect?: boolean;
}) {
    const [selectedCountry, setSelectedCountry] = useState("");

    useEffect(() => {
        if (!autoSelect) {
            return;
        }

        if (!revision) {
            onChange(null);
            return;
        }

        const availableDefaultLabels = filterDefaultLabelsForRevision(revision).map(v => v.label);

        if (availableDefaultLabels) {
            const labels = availableDefaultLabels.filter(v =>
                selectedCountry === "" ? true : v.metadata?.metadata.country === selectedCountry,
            );

            if (labels.length === 1) {
                onChange(labels[0]);
            } else {
                onChange(null);
            }
        }
    }, [autoSelect, revision, selectedCountry]);

    return (
        <>
            {revision.productTypeRevisionLabels!.filter(v => v.label.description.includes("(archived)")).length > 0 && (
                <div class="accordion my-2">
                    <div>
                        <input type="radio" name="accordion" />
                        <input type="radio" name="accordion" />
                        <div class="header">Zarchiwizowane</div>
                        <div class="content" style="flex-direction: column">
                            <div class="border border-b-0 border-gray-600 list primary">
                                {revision
                                    .productTypeRevisionLabels!.filter(v => v.label.description.includes("(archived)"))
                                    .map(v => (
                                        <div
                                            class={cn(
                                                "p-2 border-b border-b-gray-600 flex items-center cursor-pointer",
                                                v.label === selected ? "bg-[var(--primary-color)]" : "",
                                            )}
                                            onClick={() => onChange(v.label)}
                                        >
                                            <div style="font-size: 16px;">{v.label.name}</div>
                                            <div style="flex: 1 1;" />
                                            {v.label.description.includes("(archived)") ? (
                                                <div class="chip warning">Zarchiwizowane</div>
                                            ) : null}
                                            {v.label.metadata && v.label.metadata.metadata["tape-type"] ? (
                                                <div class="chip secondary" style="margin-left: 10px;">
                                                    {v.label.metadata.metadata["tape-type"]}
                                                </div>
                                            ) : null}
                                            {v.label.metadata && v.label.metadata.metadata["tape-width"] ? (
                                                <div class="chip secondary" style="margin-left: 10px;">
                                                    {v.label.metadata.metadata["tape-width"]}
                                                </div>
                                            ) : null}
                                            {v.label.type === "group" && (
                                                <div class="chip info" style="margin-left: 10px;">
                                                    Zestaw naklejek
                                                </div>
                                            )}
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <label>
                Kraj:{" "}
                <select
                    class="ml-1"
                    value={selectedCountry}
                    onChange={e => {
                        setSelectedCountry(e.currentTarget.value);
                        onChange(null);
                    }}
                >
                    <option value="">Standardowe</option>
                    {group(revision.productTypeRevisionLabels ?? [], v => v.label.metadata?.metadata.country ?? "")
                        .filter(v => v.key)
                        .map(v => (
                            <option value={v.key}>
                                {countries[v.key as keyof typeof countries]} ({v.key})
                            </option>
                        ))}
                </select>
            </label>
            <div class="mt-2 border border-b-0 border-gray-600 list primary">
                {revision
                    .productTypeRevisionLabels!.filter(
                        v =>
                            selectedCountry === (v.label.metadata?.metadata.country ?? "") &&
                            !v.label.description.includes("(archived)"),
                    )
                    .map(v => (
                        <div
                            class={cn(
                                "p-2 border-b border-b-gray-600 flex items-center cursor-pointer",
                                v.label === selected ? "bg-[var(--primary-color)]" : "",
                            )}
                            onClick={() => onChange(v.label)}
                        >
                            <div style="font-size: 16px;">{v.label.name}</div>
                            <div style="flex: 1 1;" />
                            {v.label.metadata && v.label.metadata.metadata["tape-type"] ? (
                                <div class="chip secondary" style="margin-left: 10px;">
                                    {v.label.metadata.metadata["tape-type"]}
                                </div>
                            ) : null}
                            {v.label.metadata && v.label.metadata.metadata["tape-width"] ? (
                                <div class="chip secondary" style="margin-left: 10px;">
                                    {v.label.metadata.metadata["tape-width"]}
                                </div>
                            ) : null}
                            {v.label.type === "group" && (
                                <div class="chip info" style="margin-left: 10px;">
                                    Zestaw naklejek
                                </div>
                            )}
                        </div>
                    ))}
            </div>
            {revision.productTypeRevisionLabels!.length === 0 ? (
                <div style="margin-top: 10px;">Brak naklejek dla tej rewizji</div>
            ) : null}
        </>
    );
}
